import { TipoFormatoEnvioEnum } from '../../../enums/compras/tipo-formato-envio.enum';
import { ConfiguracaoCampoStruct } from '../../structs/compras/configuracao-campo.struct';

export class ConfiguracaoCotacaoRequest {
    // Identidade visual
    public marcaSigla: string | null = null;
    public marcaRodape: string | null = null;
    public urlLogo: string | null = null;
    public corMarca: string = '#B73232';
    public corHeroInicio: string = '#1C1B1F';
    public corHeroFim: string = '#2D2A3A';

    // Dados da empresa (razão social / CNPJ / endereço vêm de db_usuario, não persistem aqui)
    public emailContato: string | null = null;
    public telefoneContato: string | null = null;

    // Portal do fornecedor
    public urlSite: string | null = null;
    public mensagem: string | null = null;

    // Formatos de envio habilitados (`TipoFormatoEnvioEnum`)
    public formatos: TipoFormatoEnvioEnum[] = [];

    // Campos do formulário habilitados
    public campos: ConfiguracaoCampoStruct[] = [];

    // E-mail de convite
    public emailAssunto: string | null = null;
    public emailCorpo: string | null = null;
}
